import { Layout} from 'antd'
import React, { useState } from 'react'
import AppHeader from './app-header/AppHeader'
import { SearchOutlined } from '@ant-design/icons'
import searchROE from './roe/SearchROE'
import AppFooter from "./app-footer/AppFooter";
const { Header, Content} = Layout

const menuContents = [
  {
    key: 'find-ROE',
    label: 'Search Rate of Exchange',
    icon: React.createElement(SearchOutlined),
    header: 'Search Rate of Exchange',
    menuContentType: searchROE
  }
]

const Comp: React.FC = () => {

  const [selectedMenuKey, setSelectedMenuKey] = useState('find-ROE')
  const { header, menuContentType: MenuContentType } = menuContents.filter(({ key }) => key === selectedMenuKey)[0]

  return (
    <>
      <AppHeader />
      <Layout style={{ height: 0, flex: 'auto' }}>
        <Layout style={{ overflow: 'auto' }}>
          <Header style={{ background: 'white', fontWeight: 'bold', fontSize: '20px' }}>
            {header}
          </Header>
          <Content style={{ minHeight: 'initial', margin: '24px' }}>
            <MenuContentType />
          </Content>
          <AppFooter />
        </Layout>
      </Layout>
    </>
  )
}

export default Comp
